import './home-gallery.scss';
import {
    gsap
} from 'gsap';

import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import {
    ScrollTrigger
} from "gsap/ScrollTrigger";



gsap.registerPlugin(ScrollTrigger);

var Isotope = require('isotope-layout');


const setDataCategory = () => {
    const $items = [...document.querySelectorAll('.specItem')];
    $items.forEach((item) => {
        if (item.classList.contains('unsort')) {
            item.setAttribute('data-category', '999')

        } else {
            const category = (Math.floor(Math.random() * 100) - 1).toString()
            item.setAttribute('data-category', category)
        }
    })
}

setDataCategory()

$(window).on('load', () => {

    const iso = new Isotope('.e-specified-gallery', {
        percentPosition: true,
        itemSelector: '.e-specified-gallery .specItem',
        layoutMode: 'fitRows',
        percentPosition: true,

        fitRows: {
            gutter: '.grid-sizer',
            gutter: '.gutter-sizer',
        },
        getSortData: {
            name: '.name',
            number: '.number parseInt',
            category: '[data-category] parseInt',
        },
    });

    iso.updateSortData()
    // Events
    document.getElementById('randBtn').addEventListener("click", e => {
        setDataCategory();
        iso.updateSortData();
        $('.filterBtn').removeClass('active')
        $(e.currentTarget).addClass('active')
        const sortValue = 'category'
        iso.arrange({
            sortBy: sortValue
        });
    })

    document.getElementById('nameBtn').addEventListener("click", e => {
        $('.filterBtn').removeClass('active')
        $(e.currentTarget).addClass('active')
        iso.updateSortData()
        iso.arrange({
            sortBy: 'name'
        })
    })

    $('.specItem a img').on('lazyloaded', (img) => {
        iso.layout()
    })
    iso.arrange({
        sortBy: 'category'
    })
})


// Animation Effekt on Scroll Images

gsap.to('#home-gallery .e-specified-gallery .specItem img', {
    scrollTrigger: '#home-gallery .e-specified-gallery',
    clipPath: 'polygon(100% 100%, 100% 0, 0 0, 0% 100%)',
    stagger: .15,
    duration: 1.55
})


// Modal specials

const $personModals = [...document.querySelectorAll('.person-modal')];
$personModals.forEach((modal) => {
    const blende = modal.querySelector('.modal-blende')
    const myImage = modal.querySelector('img');

    gsap.set(blende, { yPercent: 0 });

    modal.addEventListener('shown.bs.modal', (event) => {
        gsap.set(myImage, { opacity: 0 })
        gsap.timeline()
            .to(blende, {
                yPercent: -100,
                duration: .5,
            })
            .to(myImage, {
                opacity: 1,
                duration: .55
            })
        // .to(myImage, { y: 0  }, "=-.5")
    })
})

$personModals.forEach((modal) => {
    modal.addEventListener('show.bs.modal', (event) => {
        const myImage = modal.querySelector('img');
        const blende = modal.querySelector('.modal-blende');
        gsap.set(blende, { yPercent: 0 });
        // gsap.set(myImage, { y: 25 });
    })
})